import React from 'react'
import tabImg from "../../components/LandingPage/images/tabImg.png";


const GettingStarted = () => {
    return (
        <div>
            <div className="flex justify-center items-center mb-5">
                <h1 className="text-3xl md:text-5xl font-extrabold text-center text-[#A67FAA]" style={{ fontFamily: 'Raleway, sans-serif' }}>
                    Getting Started With Cook-E is Easy
                </h1>
            </div>
            <div className='flex justify-center items-center sm:gap-10 gap-4 p-4' >
                <p className="text-xl md:text-3xl font-bold font-sans  bg-gradient-to-r from-[#A9A8C6] to-[#A67FAA] bg-clip-text text-transparent whitespace-nowrap">
                    Explore Dishes
                </p>
                <p className="text-xl md:text-3xl font-bold font-sans bg-gradient-to-r from-[#DE519A] to-[#6A7EFC] bg-clip-text text-transparent whitespace-nowrap">
                    Save & Manage
                </p>
                <p className="text-xl md:text-3xl font-bold font-sans bg-gradient-to-r from-[#A67FAA] to-[#BFD2AC] bg-clip-text text-transparent whitespace-nowrap">
                    The Chopping Block
                </p>
            </div>
            <div className='md:mt-28 h-auto' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={tabImg} alt="Tab Image" />
            </div>
        </div>
    )
}

export default GettingStarted
